import { MenuItem, Typography, ListItemText, useTheme } from '@mui/material'
import { styled } from '@mui/material/styles'
import { Icon } from 'packages/eid-icons'

const StyledMenuItem = styled(MenuItem)(({ theme, selected }) => ({
    minWidth: '160px',
    fontSize: '13px',
    position: 'relative',
    minHeight: '40px',
    height: '40px',
    ...(selected && {
        color: theme?.palette?.primary?.main,
        backgroundColor: `${theme?.palette?.primary?.light} !important`,
        borderLeft: `2px solid ${theme?.palette?.primary?.main}`,
        '& img': {
            opacity: 1,
            filter: 'grayscale(0%) ',
        },
    }),
}))

const SortLabelText = styled(Typography)(() => ({
    color: '#aab0b4',
    fontSize: '12px',
    marginRight: '8px',
}))

const SortingMenuItem = ({ displayName, selected, onClick, order }) => {
    const theme = useTheme()

    return (
        <StyledMenuItem onClick={onClick} selected={selected}>
            <ListItemText>{displayName}</ListItemText>

            {selected && (
                <>
                    <SortLabelText>
                        {order === 'asc' ? 'A-Z' : 'Z-A'}
                    </SortLabelText>

                    <Icon
                        name="ArrowLong"
                        width="16px"
                        height="16px"
                        color={theme?.palette?.primary?.main}
                        direction={order === 'asc' ? 'down' : 'up'}
                    />
                </>
            )}
        </StyledMenuItem>
    )
}

export default SortingMenuItem
